import { Translations } from '../../contexts/Lang.context'
import { TrKey } from './trKey.cnst'

// prettier-ignore
export const TRANSLATIONS_EN: Translations = {
    // Generic
    [TrKey.name]: 'Name',
    [TrKey.emailAddress]: 'Email address',
    [TrKey.cancel]: 'Cancel',
    [TrKey.save]: 'Save',
    [TrKey.saving]: 'Saving...',
    [TrKey.list]: 'List',
    [TrKey.grid]: 'Grid',
    [TrKey.add]: 'Add',
    [TrKey.delete]: 'Delete',
    [TrKey.remove]: 'Remove',
    [TrKey.edit]: 'Edit',
    [TrKey.create]: 'Create',
    [TrKey.title]: 'Title',
    [TrKey.date]: 'Date',
    [TrKey.summary]: 'Summary',
    [TrKey.image]: 'Image',
    [TrKey.breadText]: 'Main text',
    [TrKey.publish]: 'Publish',
    [TrKey.day]: 'day',
    [TrKey.week]: 'week',
    [TrKey.size]: 'Size',
    [TrKey.type]: 'Type',
    [TrKey.select]: 'Select',
    [TrKey.close]: 'Close',
    [TrKey.done]: 'Done',
    [TrKey.somethingWentWrong]: 'Something went wrong!',
    [TrKey.new]: 'New',
  
    // Weekdays
    [TrKey.weekdayMondayPlural]: 'mondays',
    [TrKey.weekdayTuesdayPlural]: 'tuesdays',
    [TrKey.weekdayWednesdayPlural]: 'wednesdays',
    [TrKey.weekdayThursdayPlural]: 'thursdays',
    [TrKey.weekdayFridayPlural]: 'fridays',
    [TrKey.weekdaySaturdayPlural]: 'saturdays',
    [TrKey.weekdaySundayPlural]: 'sundays',
  
    // Navbar
    [TrKey.navbarItemUsers]: 'Users',
    [TrKey.navbarItemCourses]: 'Courses',
    [TrKey.navbarItemBlog]: 'News feed',
    [TrKey.navbarItemCalendar]: 'Calendar',
    [TrKey.navbarItemSponsors]: 'Sponsors',
    [TrKey.navbarItemDashboard]: 'Website',
    [TrKey.navbarItemMedia]: 'Files',
    [TrKey.navbarItemAdministrators]: 'Administrators',
    [TrKey.navbarItemAccount]: 'Account settings',
    [TrKey.navbarItemLogout]: 'Sign out',
    [TrKey.navbarMenu]: 'Menu',
    [TrKey.navbarItemECommerce]: 'E-commerce',
  
    // Dashboard
    [TrKey.dashboardWebsite]: 'Website',
    [TrKey.editWebsite]: 'Edit website',
    [TrKey.freeTierBannerText]: 'You are using a free version of Atlas Cloud that expires on {date}. <a class="underline" href="mailto:info@bucketmedia.se">Contact us</a> to sign a contract.',
    [TrKey.showLiveWebsite]: 'Show live website',
    [TrKey.deployStatusBuilding]: 'Updating',
    [TrKey.deployStatusReady]: 'Ready',
    [TrKey.deployStatusError]: 'Update failed',
    [TrKey.deployStatusPending]: 'Loading...',
  
    // Account
    [TrKey.accountSettings]: 'Account settings',
    [TrKey.accountChangePassword]: 'Change password',
    [TrKey.accountUpdateInfo]: 'Update information',
    [TrKey.accountUpdateDisclaimer]: 'When you update your account information, you need to log in again.',
    [TrKey.accountNameDescription]: 'First and last name',
    [TrKey.accountNamePlaceholder]: 'Firstname Lastname',
    [TrKey.accountEmailDescription]: 'Email address used to log in',
    [TrKey.accountCurrentPassword]: 'Current password',
    [TrKey.accountNewPassword]: 'New password',
    [TrKey.accountNewPasswordRepeat]: 'Repeat new password',
    [TrKey.accountCurrentPasswordDescription]: 'The password you have currently',
    [TrKey.accountNewPasswordDescription]: 'Select a new strong password',
    [TrKey.accountNewPasswordRepeatDescription]: 'Make sure the passwords match',
    [TrKey.accountPasswordRequirements]: 'Password requirements',
    [TrKey.accountPasswordRequirementsItem1]: 'At least 8 characters',
    [TrKey.accountPasswordRequirementsItem2]: 'At least one lowercase letter',
    [TrKey.accountPasswordRequirementsItem3]: 'At least one uppercase letter',
    [TrKey.accountPasswordRequirementsItem4]: 'At least one number',
    [TrKey.accountFailedToUpdatePassword]: 'Failed to update password',
    [TrKey.accountCheckPasswords]: 'Check passwords',
    [TrKey.accountSignInAgain]: 'Sign in again',
    [TrKey.accountPasswordUpdated]: 'Password updated',
    [TrKey.accountPasswordsDoNotMatch]: 'Passwords do not match',
    [TrKey.accountFailedToUpdateInfo]: 'Failed to update information',
    [TrKey.accountUpdatedInfo]: 'Information updated',
  
    // Sponsors
    [TrKey.sponsor]: 'Sponsor',
    [TrKey.sponsors]: 'Sponsors',
    [TrKey.sponsorsSearchPlaceholder]: 'Search sponsors',
    [TrKey.sponsorsNoSponsorsFound]: 'No sponsors found',
    [TrKey.sponsorsFailedToSave]: 'Failed to save sponsor',
    [TrKey.sponsorSaved]: 'Sponsor saved',
    [TrKey.sponsorUpdated]: 'Sponsor updated',
    [TrKey.theSponsor]: 'sponsor',
    [TrKey.sponsorsFailedToDelete]: 'Failed to delete sponsor',
    [TrKey.sponsorDeleted]: 'Sponsor deleted',
    [TrKey.sponsorName]: 'Sponsor name',
    [TrKey.sponsorNameDescription]: 'Full name of the sponsor',
    [TrKey.sponsorUrl]: 'Sponsor URL',
    [TrKey.sponsorUrlDescription]: 'Website of the sponsor',
    [TrKey.sponsorUrlPlaceholder]: 'Include "https://"',
    [TrKey.sponsorLogo]: 'Sponsor logo',
    [TrKey.sponsorLogoDescription]: 'Logo of the sponsor',
  
    // Blog
    [TrKey.blogCouldNotSavePost]: 'Failed to save post',
    [TrKey.blogPostUpdated]: 'Post updated',
    [TrKey.blogPostDuplicateTitle]: 'Another post has the same title',
    [TrKey.blogPostSaved]: 'Post saved',
    [TrKey.theBlogPost]: 'post',
    [TrKey.blogCouldNotDeletePost]: 'Failed to delete post',
    [TrKey.blogPostDeleted]: 'Post deleted',
    [TrKey.blogMissingWebsite]: 'There is no website connected to this account. <a class="underline" href="mailto:info@bucketmedia.se">Contact us</a> for help.',
    [TrKey.blogTitle]: 'News feed',
    [TrKey.blogCreatePost]: 'Create post',
    [TrKey.blogSearchPosts]: 'Search posts',
    [TrKey.blogNoPostsFound]: 'No posts found',
    [TrKey.blogPost]: 'post',
    [TrKey.blogPostTitleDescription]: 'Title of the post',
    [TrKey.blogPostTitlePlaceholder]: 'My title',
    [TrKey.blogPostDateDescription]: 'Date of the post',
    [TrKey.blogPostDatePlaceholder]: 'YYYY-MM-DD',
    [TrKey.blogPostSummaryDescription]: 'Short summary of the post',
    [TrKey.blogPostSummaryPlaceholder]: 'Summary',
    [TrKey.blogPostImageDescription]: 'Main image of the post',
    [TrKey.blogPostBreadTextDescription]: 'Main text of the post',
    [TrKey.blogPostDelayPublishing]: 'Delay publishing',
    [TrKey.blogPostDelayPublishingUntil]: 'Delay publishing until date',
    [TrKey.blogPostRemoveDelayedPublishing]: 'Remove delayed publishing',
  
    // Calendar
    [TrKey.calendarCouldNotSaveEvent]: 'Failed to save event',
    [TrKey.calendarEventSaved]: 'Event saved',
    [TrKey.calendarTheEvent]: 'event',
    [TrKey.calendarCouldNotDeleteEvent]: 'Failed to delete event',
    [TrKey.calendarEventDeleted]: 'Event deleted',
    [TrKey.calendarCouldNotUpdateEvent]: 'Failed to update event',
    [TrKey.calendarEventUpdated]: 'Event updated',
    [TrKey.calendarRepeatStringDay]: 'Repeats every day at {startTime} - {endTime}',
    [TrKey.calendarRepeatStringWeek]: 'Repeats every week on {weekday} at {startTime} - {endTime}',
    [TrKey.calendarTitle]: 'Calendar',
    [TrKey.calendarCreateEvent]: 'Create event',
    [TrKey.calendarNoEventsFound]: 'No events found',
    [TrKey.calendarEndTimeBeforeStartTime]: 'End time cannot be before start time',
    [TrKey.calendarEvent]: 'event',
    [TrKey.calendarEventSummaryLabel]: 'Description',
    [TrKey.calendarEventSummaryDescription]: 'Name of the event',
    [TrKey.calendarEventStartTimeLabel]: 'Start time',
    [TrKey.calendarEventStartTimeDescription]: 'Time the event starts',
    [TrKey.calendarEventEndTimeLabel]: 'End time',
    [TrKey.calendarEventEndTimeDescription]: 'Time the event ends',
    [TrKey.calendarEventRepeatOptionsLabel]: 'Repeat event',
    [TrKey.calendarEventRepeatOptionsDescription]: 'Repeat the event regularly',
    [TrKey.calendarEventRepeatEvery]: 'Repeat every',
    [TrKey.calendarRepeatOptionsUntil]: 'until',
    [TrKey.calendarRepeatOptionsCancelledDatesLabel]: 'Cancelled dates',
    [TrKey.calendarRepeatOptionsCancelledDatesDescription]: 'Select dates that should not be shown in the calendar',
    [TrKey.calendarRepeatOptionsCancelledDatesPlaceholder]: 'Select date to cancel',
    [TrKey.calendarLocationNameLabel]: 'Location',
    [TrKey.calendarLocationNameDescription]: 'Name of the location of the event',
    [TrKey.calendarLocationAddressLabel]: 'Address',
    [TrKey.calendarLocationAddressDescription]: 'Address used for Google Maps',
    [TrKey.calendarBreadTextDescription]: 'Text content of the event',
  
    // Media
    [TrKey.mediaRouteTitle]: 'Files',
    [TrKey.mediaTypeAll]: 'All files',
    [TrKey.mediaTypeImage]: 'Images',
    [TrKey.mediaTypeVideo]: 'Videos',
    [TrKey.mediaTypePdf]: 'PDFs',
    [TrKey.mediaFailedToFetchFiles]: 'Something went wrong when fetching the files',
    [TrKey.mediaNoFilesFound]: 'No files found',
    [TrKey.mediaTheFile]: 'file',
    [TrKey.mediaCouldNotDeleteFile]: 'Failed to delete file',
    [TrKey.mediaFileDeleted]: 'File deleted',
    [TrKey.mediaUsageQuota]: 'Used space: {used} / {total} GB',
    [TrKey.mediaSearchFileName]: 'Search file name',
    [TrKey.mediaUploadedAt]: 'Uploaded',
    [TrKey.mediaUsed]: 'Used',
    [TrKey.mediaUsedIn]: 'The file is used in {usedIn}. Files that are used cannot be deleted',
    [TrKey.mediaFileTooLarge]: '{fileName} is too large (max {maxSize})',
    [TrKey.mediaInvalidFile]: '{fileName} is not a valid file',
    [TrKey.mediaFilesUploaded]: 'Files uploaded!',
    [TrKey.mediaUploadError]: 'An error occurred during upload',
    [TrKey.mediaDropImages]: 'Drop files to upload!',
    [TrKey.mediaDragNDrop]: 'Drag and drop files here, or click to select files',
    [TrKey.mediaMaxFileSize]: 'Max {maxSize} per file',
    [TrKey.mediaUploading]: 'Uploading...',
  
    // Courses
    [TrKey.coursesRouteTitle]: 'Courses',
    [TrKey.createCourse]: 'Create course',
    [TrKey.theCourse]: 'course',
    [TrKey.coursesFailedToDelete]: 'Failed to delete course',
    [TrKey.coursesCourseDeleted]: 'Course deleted',
    [TrKey.coursesFailedToCreate]: 'Failed to create course',
    [TrKey.coursesCourseCreated]: 'Course created',
    [TrKey.courseNameDescription]: 'Name of the course',
    [TrKey.courseNamePlaceholder]: 'My course',
    [TrKey.courseLastUpdated]: 'Last updated',
    [TrKey.coursePublished]: 'Published',
    [TrKey.courseNotPublished]: 'Not published',
  
    // Users
    [TrKey.usersRouteTitle]: 'Administrators',
    [TrKey.usersCreateUser]: 'Add administrator',
    [TrKey.usersTheUser]: 'administrator',
    [TrKey.usersFailedToDelete]: 'Failed to delete administrator',
    [TrKey.usersUserDeleted]: 'Administrator deleted',
    [TrKey.usersFailedToCreate]: 'Failed to create administrator',
    [TrKey.usersUserCreated]: 'Administrator created',
    [TrKey.usersFailedToUpdate]: 'Failed to update administrator',
    [TrKey.usersUserUpdated]: 'Administrator updated',
    [TrKey.usersLastLogin]: 'Last login',
    [TrKey.usersFullNameDescription]: 'First and last name',
    [TrKey.usersFullNamePlaceholder]: 'Firstname Lastname',
    [TrKey.usersEmailDescription]: 'The administrator will be invited to this email address',
    [TrKey.usersYou]: 'You',
  
    // CustomerUsers
    [TrKey.customerUsersRouteTitle]: 'Users',
    [TrKey.customerUsersCreateUser]: 'Add user',
    [TrKey.customerUsersTheUser]: 'user',
    [TrKey.customerUsersFailedToDelete]: 'Failed to delete user',
    [TrKey.customerUsersUserDeleted]: 'User deleted',
    [TrKey.customerUsersFailedToCreate]: 'Failed to create user',
    [TrKey.customerUsersUserCreated]: 'User created',
    [TrKey.customerUsersFailedToUpdate]: 'Failed to update user',
    [TrKey.customerUsersUserUpdated]: 'User updated',
    [TrKey.customerUsersFullNameDescription]: 'First and last name',
    [TrKey.customerUsersFillNamePlaceholder]: 'Firstname Lastname',
    [TrKey.customerUsersEmailDescription]: 'The user will be invited to this email address',
  
    // Website analytics
    [TrKey.analyticsTitle]: 'Analytics',
    [TrKey.analyticsPeriod]: 'Analytics period',
    [TrKey.analyticsPeriodLastWeek]: 'Last week',
    [TrKey.analyticsPeriodLast2Weeks]: 'Last 2 weeks',
    [TrKey.analyticsPeriodLast30Days]: 'Last 30 days',
    [TrKey.analyticsOverview]: 'Overview',
  
    // Website analytics single value
    [TrKey.analyticsTotalPageViews]: 'Total page views',
    [TrKey.analyticsUniqueUsers]: 'Unique users',
    [TrKey.analyticsAvgEngagementTime]: 'Average engagement time',
    [TrKey.analyticsPageViewsLast5Minutes]: 'Page views last 5 minutes',
    [TrKey.analyticsUniqueUsersLast5Minutes]: 'Unique users last 5 minutes',
  
    // Website analytics graph
    [TrKey.analyticsUniqueUsersOverTime]: 'Unique users',
    [TrKey.analyticsUsersPerRoute]: 'Users per page',
    [TrKey.analyticsUsersPerReferer]: 'Source',
    [TrKey.analyticsUsersPerDevice]: 'Device',
    [TrKey.analyticsUsersPerPlatform]: 'Platform',
    [TrKey.analyticsUsersPerOS]: 'Operating system',
    [TrKey.analyticsUsersPerVendor]: 'Vendor',
    [TrKey.analyticsUsersPerCountry]: 'Country',
    [TrKey.analyticsAvgEngagementTimeOverTime]: 'Average engagement time',
    [TrKey.analyticsAvgEngagementTimePerRoute]: 'Average engagement time per page',
  
    // Login
    [TrKey.loginTitle]: 'Login',
    [TrKey.loginEmailLabel]: 'Email address',
    [TrKey.loginPasswordLabel]: 'Password',
    [TrKey.loginForgotPassword]: 'Forgot password?',
    [TrKey.loginLoggingIn]: 'Logging in...',
    [TrKey.loginGenericError]: 'Wrong email address or password',
  
    // Delete confirmation
    [TrKey.deleteConfirmationText]: 'Enter the following in the text field to confirm:',
    [TrKey.deleteConfirmationMismatch]: 'The text does not match, try again.',

    // Confirm provider
    [TrKey.confirmProviderDefaultTitle]: 'Please confirm',
    [TrKey.confirmProviderDefaultProceed]: 'Proceed',
  
    // Media input
    [TrKey.mediaInputSelectMedia]: 'Select media',
    [TrKey.mediaInputChangeMedia]: 'Change media',
    [TrKey.mediaInputRemoveMedia]: 'Remove media',
    [TrKey.imageInputSelectImage]: 'Select image',
    [TrKey.imageInputChangeImage]: 'Change image',
    [TrKey.imageInputRemoveImage]: 'Remove image', 

    // Editor
    [TrKey.editorHaveYouSaved]: 'Have you saved your changes?',
    [TrKey.editorRouteTitle]: 'Website editor',
    [TrKey.editorBackToOverview]: 'Back to overview',
    [TrKey.editorTabContent]: 'Content',
    [TrKey.editorTabSettings]: 'Settings',
    [TrKey.editorTabSitemap]: 'Sitemap',
    [TrKey.editorShowMenu]: 'Show menu',
    [TrKey.editorHideMenu]: 'Hide menu',
    [TrKey.editorStaticComponents]: 'Static components',
    [TrKey.editorStaticComponentsTooltip]: 'Click on the components to add them to the page. You can only use one of each component per page.',
    [TrKey.editorAdd]: 'Add',
    [TrKey.editorDynamicComponents]: 'Dynamic components',
    [TrKey.editorDynamicComponentsTooltip]: 'Drag the components into a section to add them to the page.',
    [TrKey.editorLeftColorsTitle]: 'Colors',
    [TrKey.editorLeftBaseColorLabel]: 'Base color',
    [TrKey.editorLeftBaseColorDescription]: 'Your base color',
    [TrKey.editorLeftBaseColorPlaceholder]: 'HEX code',
    [TrKey.editorLeftAccentColorLabel]: 'Accent color',
    [TrKey.editorLeftAccentColorDescription]: 'Your accent color',
    [TrKey.editorLeftAccentColorPlaceholder]: 'HEX code',
    [TrKey.editorLeftLogoTitle]: 'Logo',
    [TrKey.editorLeftLogoWideLabel]: 'Logo',
    [TrKey.editorLeftLogoWideDescription]: 'Wide version of your logo',
    [TrKey.editorLeftLogoSquareLabel]: 'Logo',
    [TrKey.editorLeftLogoSquareDescription]: 'Square version of your logo',
    [TrKey.editorLeftContactTitle]: 'Contact information',
    [TrKey.editorLeftContactRecipientLabel]: 'Recipient',
    [TrKey.editorLeftContactAdressLabel]: 'Address',
    [TrKey.editorLeftContactPostalCodeLabel]: 'Postal code',
    [TrKey.editorLeftContactPostalAreaLabel]: 'Postal area',
    [TrKey.editorLeftContactPhoneLabel]: 'Phone',
    [TrKey.editorLeftContactEmailLabel]: 'Email',
    [TrKey.editorLeftNavBackgroundLabel]: 'Navigation background',
    [TrKey.editorLeftNavBackgroundDescription]: 'Shown when the page is scrolled',
    [TrKey.editorLeftSocialTitle]: 'Social media',
    [TrKey.editorLeftContactFooterTextLabel]: 'Footer text',
    [TrKey.editorLeftContactFooterImageLabel]: 'Footer image',
    [TrKey.editorLeftPageConfigTitle]: 'Page configuration',
    [TrKey.editorLeftPageConfigWebsiteBackgroundLabel]: 'Website background',
    [TrKey.editorLeftPageConfigWebsiteBackgroundDescription]: 'Applies to all pages on the website',
    [TrKey.editorLeftPageConfigPageMaxWidthLabel]: 'Page max width',
    [TrKey.editorLeftPageConfigPageMaxWidthDescription]: 'Applies to all pages on the website',
    [TrKey.editorLeftPageConfigPageContentAnimationLabel]: 'Animations',
    [TrKey.editorLeftPageConfigPageContentAnimationDescription]: 'Animates the content of the page',
    [TrKey.editorBackgroundColorOptionStandard]: 'Standard',
    [TrKey.editorBackgroundColorOptionWhite]: 'White',
    [TrKey.editorBackgroundColorOptionOffWhite]: 'Off-white',
    [TrKey.editorLeftPageConfigPageMaxWidthOptionNormal]: 'Normal',
    [TrKey.editorLeftPageConfigPageMaxWidthOptionWide]: 'Wide',
    [TrKey.editorLeftPageConfigPageContentAnimationOptionNone]: 'No animation',
    [TrKey.editorLeftPageConfigPageContentAnimationOptionFadeBottom]: 'Fade from bottom',
    [TrKey.editorLeftSelectFooterPlaceholder]: 'Select footer',
    [TrKey.editorLeftSelectNavPlaceholder]: 'Select navigation',
    [TrKey.editorLeftSelectFontPlaceholder]: 'Select font',
    [TrKey.editorPageFormPageNameMissing]: 'Page name is required',
    [TrKey.editorPageFormPageNameReserved]: 'Page name is reserved, choose another name',
    [TrKey.editorPageFormPage]: 'page',
    [TrKey.editorPageFormPageNameLabel]: 'Page name',
    [TrKey.editorPageFormPageNameDescription]: 'Name of the page',
    [TrKey.editorPageFormAuthOnlyLabel]: 'Authenticated only',
    [TrKey.editorPageFormAuthOnlyDescription]: 'If you choose this option, only logged in users can see the page',
    [TrKey.editorSitemapTopLevel]: 'top level',
    [TrKey.editorSitemapEditing]: 'Editing',
    [TrKey.editorSitemapEditingTooltip]: 'Here you can change the order of pages in the navigation, add pages, or choose which page you want to edit.',
    [TrKey.editorSitemapBackTo]: 'Back to',
    [TrKey.editorSitemapNoPages]: 'There are no subpages yet',
    [TrKey.editorSitemapAddPage]: 'Add new page',
    [TrKey.editorTopPreviewMobile]: 'Preview for mobile',
    [TrKey.editorTopPreviewDesktop]: 'Preview for desktop',
    [TrKey.editorTopSaved]: 'Saved',
    [TrKey.editorTopPublished]: 'Published',
    [TrKey.editorTopPublishing]: 'Publishing...',
    [TrKey.editorTopPublish]: 'Publish',
    [TrKey.editorTopBack]: 'Leave editor',
    [TrKey.editorNoPageSelected]: 'No page selected',
    [TrKey.editorEditingPage]: 'You are editing page "{pageName}"',
    [TrKey.editorPressEscapeToLeaveFullscreen]: 'Press escape to leave fullscreen',
    [TrKey.editorRemovePageConfirmationTitle]: 'Remove page',
    [TrKey.editorRemovePageConfirmationText]: 'Are you sure you want to remove this page?',
    [TrKey.editorUnsavedChangesMessage]: 'There are unsaved changes. Are you sure you want to leave the editor?',
    [TrKey.editorUnsavedChangesTitle]: 'Unsaved changes',
    [TrKey.editorUnsavedChangesProceed]: 'Leave without saving',
    [TrKey.editorUnsavedChangesAbort]: 'Stay',
    [TrKey.editorRightEditingTooltip]: 'Here you can edit the content and settings for {contentType}',

    // Content type editors
    [TrKey.textSettings]: 'Text settings',
    [TrKey.marginOptionsTitle]: 'Margins',
    [TrKey.marginOptionsTopLabel]: 'Top margin',
    [TrKey.marginOptionsTopDescription]: 'How much space there is above the content',
    [TrKey.marginOptionsBottomLabel]: 'Bottom margin',
    [TrKey.marginOptionsBottomDescription]: 'How much space there is below the content',
    [TrKey.marginOptionsPlaceholder]: 'Select a value',

    [TrKey.textAlignmentLabel]: 'Placement',
    [TrKey.textAlignmentDescription]: 'Text alignment',
    [TrKey.textAlignmentOptionLeft]: 'Left',
    [TrKey.textAlignmentOptionRight]: 'Right',
    [TrKey.textAlignmentOptionCenter]: 'Center',
    [TrKey.textAlignmentOptionCenterMobile]: 'Center on mobile',

    [TrKey.fontWeightLabel]: 'Weight',
    [TrKey.fontWeightDescription]: 'Font weight',
    [TrKey.fontWeightOptionThin]: 'Thin',
    [TrKey.fontWeightOptionExtralight]: 'Extra light',
    [TrKey.fontWeightOptionLight]: 'Light',
    [TrKey.fontWeightOptionNormal]: 'Normal',
    [TrKey.fontWeightOptionMedium]: 'Medium',
    [TrKey.fontWeightOptionSemibold]: 'Semi bold',
    [TrKey.fontWeightOptionBold]: 'Bold',
    [TrKey.fontWeightOptionExtrabold]: 'Extra bold',
    [TrKey.fontWeightOptionBlack]: 'Black',

    [TrKey.textColorLabel]: 'Color',
    [TrKey.textColorDescription]: 'Text color',
    [TrKey.textColorOptionBlack]: 'Black',
    [TrKey.textColorOptionWhite]: 'White',
    [TrKey.textColorOptionNeutral700]: 'Dark grey',
    [TrKey.textColorOptionPrimary400]: 'Primary color',
    [TrKey.textColorOptionPrimary300]: 'Primary color light',
    [TrKey.textColorOptionPrimary200]: 'Primary color lighter',

    [TrKey.fontSizeLabel]: 'Size',
    [TrKey.fontSizeDescription]: 'Font size',

    [TrKey.leadingLabel]: 'Leading',
    [TrKey.leadingDescription]: 'Line height',

    [TrKey.textMaxWidthLabel]: 'Max width',
    [TrKey.textMaxWidthDescription]: 'Limits the maximum width of the text',
    [TrKey.textMaxWidthOptionNone]: 'None',

    [TrKey.gridEditorLayoutLabel]: 'Layout',
    [TrKey.gridEditorLayoutDescription]: 'How the section is divided',
    [TrKey.gridEditorLayoutPlaceholder]: 'Select layout',
    [TrKey.gridEditorLayoutFullWidth]: 'Full width',
    [TrKey.gridEditorGapLabel]: 'Gap',
    [TrKey.gridEditorGapDescription]: 'How much space there is between the columns',
    [TrKey.gridEditorDirectionLabel]: 'Column sorting',
    [TrKey.gridEditorDirectionDescription]: 'Which column is on top in mobile view',
    [TrKey.gridEditorDirectionLeftLabel]: 'Left first',
    [TrKey.gridEditorDirectionRightLabel]: 'Right first',
    [TrKey.gridEditorTopLineLabel]: 'Top line',
    [TrKey.gridEditorTopLineDescription]: 'Adds a line above the section',
    [TrKey.gridEditorBottomLineLabel]: 'Bottom line',
    [TrKey.gridEditorBottomLineDescription]: 'Adds a line below the section',
    [TrKey.gridEditorBackgroundLabel]: 'Background',
    [TrKey.gridEditorBackgroundOptionNone]: 'None',
    [TrKey.gridEditorBackgroundOptionPrimary]: 'Primary',
    [TrKey.gridEditorBackgroundOptionAccent]: 'Accent',

    [TrKey.headerEditorTextLabel]: 'Header text',
    [TrKey.headerEditorTextPlaceholder]: 'My header',

    [TrKey.imageCardsEditorCard]: 'Card',
    [TrKey.imageCardsEditorHeader]: 'Header',
    [TrKey.imageCardsEditorParagraph]: 'Paragraph',
    [TrKey.imageCardsEditorButtonText]: 'Button text',
    [TrKey.imageCardsEditorButtonLink]: 'Button link',

    [TrKey.bulletPointsEditorRow]: 'Row',
    [TrKey.bulletPointsEditorText]: 'Text',

    [TrKey.svgInputLabel]: 'Icon',
    [TrKey.svgInputPlaceholder]: 'Search icon',

    [TrKey.logoSectionEditorLogo]: 'Logo',
    [TrKey.logoSectionEditorCompanyName]: 'Company name',
    [TrKey.logoSectionEditorLink]: 'Link',

    [TrKey.imageCollageEditorMainImage]: 'Main image',
    [TrKey.imageCollageEditorSecondaryImage]: 'Secondary image',
    [TrKey.imageCollageEditorSettingsTitle]: 'Image settings',
    [TrKey.imageCollageEditorLayoutLabel]: 'Layout',
    [TrKey.imageCollageEditorLayoutDescription]: 'Placement of the secondary image',
    [TrKey.imageCollageEditorLayoutOptionBottomLeft]: 'Bottom left',
    [TrKey.imageCollageEditorLayoutOptionBottomRight]: 'Bottom right',

    [TrKey.imageOptionsRoundedLabel]: 'Rounding',
    [TrKey.imageOptionsRoundedDescription]: 'Rounding of the corners of the image',
    [TrKey.imageOptionsRoundedOptionNone]: 'None',
    [TrKey.imageOptionsRoundedOptionMedium]: 'Medium',
    [TrKey.imageOptionsRoundedOptionXLarge]: 'Large',
    [TrKey.imageOptionsShadowLabel]: 'Shadow',
    [TrKey.imageOptionsShadowDescription]: 'Shadow of the image',
    [TrKey.imageOptionsShadowOptionNone]: 'None',
    [TrKey.imageOptionsShadowOptionMedium]: 'Medium',
    [TrKey.imageOptionsShadowOptionXLarge]: 'Large',

    [TrKey.serviceCardEditorHeaderLabel]: 'Header text',
    [TrKey.serviceCardEditorHeaderPlaceholder]: 'My header',
    [TrKey.serviceCardEditorButtonTextLabel]: 'Button text',
    [TrKey.serviceCardEditorButtonTextPlaceholder]: 'My button text',
    [TrKey.serviceCardEditorButtonLinkLabel]: 'Button link',
    [TrKey.serviceCardEditorButtonLinkPlaceholder]: '/my-page',

    [TrKey.buttonEditorButtonTextLabel]: 'Button text',
    [TrKey.buttonEditorButtonTextPlaceholder]: 'My button',
    [TrKey.buttonEditorButtonLinkLabel]: 'Button link',
    [TrKey.buttonEditorButtonLinkDescription]: 'Where the button links to',
    [TrKey.buttonEditorButtonLinkPlaceholder]: '/',
    [TrKey.buttonEditorButtonSettingsTitle]: 'Button settings',
    [TrKey.buttonEditorColorLabel]: 'Color',
    [TrKey.buttonEditorColorDescription]: 'Select a color for the button',
    [TrKey.buttonEditorColorOptionCustomer]: 'Customer',
    [TrKey.buttonEditorColorOptionAccent]: 'Accent',
    [TrKey.buttonEditorColorOptionDark]: 'Dark',
    [TrKey.buttonEditorColorOptionLight]: 'Light',
    [TrKey.buttonEditorTypeLabel]: 'Button type',
    [TrKey.buttonEditorTypeDescription]: 'Select a type for the button',
    [TrKey.buttonEditorTypeOptionFilled]: 'Filled',
    [TrKey.buttonEditorTypeOptionOutline]: 'Outline',

    [TrKey.imageEditorImageLabel]: 'Image',
    [TrKey.imageEditorImageTextLabel]: 'Image text',
    [TrKey.imageEditorImageTextDescription]: 'Text below the image',
    [TrKey.imageEditorImageSettingsTitle]: 'Image settings',

    [TrKey.galleryEditorAddImage]: 'Add image',
    [TrKey.galleryEditorImageSettingsTitle]: 'Image settings',

    [TrKey.formEditorNewField]: 'New field',
    [TrKey.formEditorContactEmailLabel]: 'Contact email',
    [TrKey.formEditorContactEmailDescription]: 'Email address that messages are sent to',
    [TrKey.formEditorSubmitTextLabel]: 'Submit button text',
    [TrKey.formEditorSubmitTextDescription]: 'Text that appears on the submit button',
    [TrKey.formEditorSuccessTextLabel]: 'Message on successful submission',
    [TrKey.formEditorSuccessTextDescription]: 'Shows under the form when the message is sent',
    [TrKey.formEditorSenderConfirmationEmailSubjectLabel]: 'Subject',
    [TrKey.formEditorSenderConfirmationEmailSubjectDescription]: 'Subject line for the confirmation email to the sender',
    [TrKey.formEditorSenderConfirmationEmailBodyLabel]: 'Body',
    [TrKey.formEditorSenderConfirmationEmailBodyDescription]: 'Text content for the confirmation email to the sender',
    [TrKey.formEditorSenderConfirmationEmailImageLabel]: 'Image',
    [TrKey.formEditorSenderConfirmationEmailImageDescription]: 'Shown in the footer of the email',
    [TrKey.formEditorFieldsTitle]: 'Fields',
    [TrKey.formEditorFieldNameLabel]: 'Name of the field',
    [TrKey.formEditorRequiredLabel]: 'Required',
    [TrKey.formEditorFieldTypePlaceholder]: 'Select field type',
    [TrKey.formEditorFieldTypeOptionText]: 'Text',
    [TrKey.formEditorFieldTypeOptionTextarea]: 'Textarea',
    [TrKey.formEditorFieldTypeOptionEmail]: 'Email',
    [TrKey.formEditorFieldTypeOptionTel]: 'Phone',
    [TrKey.formEditorFieldWidthPlaceholder]: 'Select width',
    [TrKey.formEditorFieldWidthOptionFull]: 'Full width',
    [TrKey.formEditorFieldWidthOptionHalf]: 'Half width',
    [TrKey.formEditorAddField]: 'Add field',

    [TrKey.videoHeroEditorContentTitle]: 'Content',
    [TrKey.videoHeroEditorHeaderTextLabel]: 'Header text',
    [TrKey.videoHeroEditorHeaderTextPlaceholder]: 'My header',
    [TrKey.videoHeroEditorHeaderTextDescription]: 'Header text for the top section',
    [TrKey.videoHeroEditorParagraphTextLabel]: 'Paragraph text',
    [TrKey.videoHeroEditorParagraphTextPlaceholder]: 'My paragraph',
    [TrKey.videoHeroEditorParagraphTextDescription]: 'Paragraph text for the top section',
    [TrKey.videoHeroEditorCtaTextLabel]: 'Button text',
    [TrKey.videoHeroEditorCtaTextPlaceholder]: 'My button text',
    [TrKey.videoHeroEditorCtaTextDescription]: 'Text that appears on the button',
    [TrKey.videoHeroEditorCtaLinkLabel]: 'Button link',
    [TrKey.videoHeroEditorCtaLinkPlaceholder]: 'Include "https://"',
    [TrKey.videoHeroEditorCtaLinkDescription]: 'Where the button links to',
    [TrKey.videoHeroEditorOverlayPercentageLabel]: 'Overlay',
    [TrKey.videoHeroEditorOverlayPercentageDescription]: 'Darkens the video to make the text more readable',
    [TrKey.videoHeroEditorOverlayPercentageOptionNone]: 'No overlay',
    [TrKey.videoHeroEditorVideoTitle]: 'Video',
    [TrKey.videoHeroEditorNoVideoSelected]: 'No video selected',
    [TrKey.videoHeroEditorChangeVideo]: 'Change video',
    [TrKey.videoHeroEditorSelectVideo]: 'Select video',

    [TrKey.topSectionEditorHeaderTextLabel]: 'Header',
    [TrKey.topSectionEditorHeaderTextPlaceholder]: 'My header',
    [TrKey.topSectionEditorHeaderTextDescription]: 'Header text for the top section',
    [TrKey.topSectionEditorAccentTitle]: 'Accent',
    [TrKey.topSectionEditorAccentLabel]: 'Accent for header',
    [TrKey.topSectionEditorAccentDescription]: 'Write a part of the header that will get the page\'s accent color',
    [TrKey.topSectionEditorAccentPlaceholder]: 'Part of header',
    [TrKey.topSectionEditorParagraphTextLabel]: 'Sub header',
    [TrKey.topSectionEditorParagraphTextPlaceholder]: 'My sub header',
    [TrKey.topSectionEditorParagraphTextDescription]: 'Sub header text for the top section',
    [TrKey.topSectionEditorCtaTextLabel]: 'Button text',
    [TrKey.topSectionEditorCtaTextPlaceholder]: 'My button text',
    [TrKey.topSectionEditorCtaTextDescription]: 'Text that appears on the button',
    [TrKey.topSectionEditorCtaLinkLabel]: 'Button link',
    [TrKey.topSectionEditorCtaLinkPlaceholder]: 'Include "https://"',
    [TrKey.topSectionEditorCtaLinkDescription]: 'Where the button links to',
    [TrKey.topSectionEditorCtaColorLabel]: 'Button color',
    [TrKey.topSectionEditorCtaColorDescription]: 'Color of the button',
    [TrKey.topSectionCtaColorOptionPrimary]: 'Primary',
    [TrKey.topSectionCtaColorOptionAccent]: 'Accent',
    [TrKey.topSectionEditorOverlayTitle]: 'Overlay',
    [TrKey.topSectionEditorOverlayColorLabel]: 'Overlay color',
    [TrKey.topSectionEditorOverlayColorDescription]: 'Color that appears over the image',
    [TrKey.topSectionEditorOverlayColorPlaceholder]: 'Select color',
    [TrKey.topSectionOverlayColorOptionWhite]: 'White',
    [TrKey.topSectionOverlayColorOptionGray200]: 'Light grey',
    [TrKey.topSectionOverlayColorOptionGray400]: 'Medium grey',
    [TrKey.topSectionOverlayColorOptionGray600]: 'Dark grey',
    [TrKey.topSectionOverlayColorOptionBlack]: 'Black',
    [TrKey.topSectionEditorOverlayStrengthLabel]: 'Overlay strength',
    [TrKey.topSectionEditorOverlayStrengthDescription]: 'How strong the overlay is',
    [TrKey.topSectionEditorOverlayStrengthPlaceholder]: 'Select strength',
    [TrKey.topSectionOverlayStrengthOption02]: 'Weak',
    [TrKey.topSectionOverlayStrengthOption05]: 'Medium',
    [TrKey.topSectionOverlayStrengthOption07]: 'Strong',
    [TrKey.topSectionOverlayStrengthOption1]: 'Full',
    [TrKey.topSectionEditorImageCarouselTitle]: 'Image carousel',
    [TrKey.topSectionEditorImageCarouselLabel]: 'Images',
    [TrKey.topSectionEditorImageCarouselDescription]: 'Select one or more images',
    [TrKey.topSectionEditorImageCarouselAddImage]: 'Add image',
    [TrKey.topSectionEditorHeightLabel]: 'Height',
    [TrKey.topSectionEditorHeightDescription]: 'Height of the top section',
    [TrKey.topSectionEditorHeightPlaceholder]: 'Select height',
    [TrKey.topSectionEditorHeightOptionLow]: 'Low',
    [TrKey.topSectionEditorHeightOptionMedium]: 'Medium',
    [TrKey.topSectionEditorHeightOptionHigh]: 'High',
    [TrKey.topSectionEditorMarginBottomLabel]: 'Margin bottom',
    [TrKey.topSectionEditorMarginBottomDescription]: 'How much space there is below the top section',
    [TrKey.topSectionEditorMarginBottomPlaceholder]: 'Select value',

    [TrKey.quickLinksEditorMyLink]: 'My link',
    [TrKey.quickLinksEditorLink]: 'Link',
    [TrKey.quickLinksEditorTextLabel]: 'Text',
    [TrKey.quickLinksEditorTextDescription]: 'Text that appears on the link card',
    [TrKey.quickLinksEditorLinkLabel]: 'Link address',
    [TrKey.quickLinksEditorLinkDescription]: 'Address the link points to',
    [TrKey.quickLinksEditorLinkPlaceholder]: 'Include "https://"',
    [TrKey.quickLinksEditorLinkRemove]: 'Remove link',
    [TrKey.quickLinksEditorLinkAdd]: 'Add link',
    [TrKey.quickLinksEditorColorLabel]: 'Color',
    [TrKey.quickLinksEditorColorOptionWhite]: 'White',
    [TrKey.quickLinksEditorColorOptionPrimary]: 'Primary',
    [TrKey.quickLinksEditorColorOptionAccent]: 'Accent',

    [TrKey.accordionEditorTitleLabel]: 'Title',
    [TrKey.accordionEditorTitleDescription]: 'Title that is shown before an accordion expands',
    [TrKey.accordionEditorContentLabel]: 'Text content',
    [TrKey.accordionEditorMarginBottomLabel]: 'Margin bottom',
    [TrKey.accordionEditorMarginBottomDescription]: 'How much space there is below the accordion',
    [TrKey.accordionEditorMarginBottomPlaceholder]: 'Select value',

    [TrKey.tipsBoxEditorTextLabel]: 'Text content',
    [TrKey.tipsBoxEditorMarginBottomLabel]: 'Margin bottom',
    [TrKey.tipsBoxEditorMarginBottomDescription]: 'How much space there is below the tips box',
    [TrKey.tipsBoxEditorMarginBottomPlaceholder]: 'Select value',
    [TrKey.tipsBoxEditorAlignmentLabel]: 'Placement',
    [TrKey.tipsBoxEditorAlignmentPlaceholder]: 'Select value',
    [TrKey.tipsBoxEditorAlignmentOptionLeft]: 'Left',
    [TrKey.tipsBoxEditorAlignmentOptionCenter]: 'Center',

    [TrKey.documentEditorButtonTextLabel]: 'Button text',
    [TrKey.documentEditorButtonTextDescription]: 'Text that appears on the button',
    [TrKey.documentEditorButtonTextPlaceholder]: 'My button text',
    [TrKey.documentEditorDocumentLabel]: 'Document',
    [TrKey.documentEditorNoDocumentSelected]: 'No document selected',
    [TrKey.documentEditorChangeDocument]: 'Change document',
    [TrKey.documentEditorSelectDocument]: 'Select document',
    [TrKey.documentEditorMarginBottomLabel]: 'Margin bottom',
    [TrKey.documentEditorMarginBottomDescription]: 'How much space there is below the document button',
    [TrKey.documentEditorMarginBottomPlaceholder]: 'Select value',

    [TrKey.blogEditorMarginBottomLabel]: 'Margin bottom',
    [TrKey.blogEditorMarginBottomDescription]: 'How much space there is below the news feed',
    [TrKey.blogEditorMarginBottomPlaceholder]: 'Select value',

    [TrKey.calendarEditorMarginBottomLabel]: 'Margin bottom',
    [TrKey.calendarEditorMarginBottomDescription]: 'How much space there is below the calendar',
    [TrKey.calendarEditorMarginBottomPlaceholder]: 'Select value',

    [TrKey.contactFormEditorHeaderLabel]: 'Header',
    [TrKey.contactFormEditorHeaderDescription]: 'Header for the form',
    [TrKey.contactFormEditorInstructionLabel]: 'Instruction',
    [TrKey.contactFormEditorInstructionDescription]: 'What the user is expected to enter in the form.',
    [TrKey.contactFormEditorInstructionPlaceholder]: 'Contact us about...',
    [TrKey.contactFormEditorResponseEmailLabel]: 'Response email',
    [TrKey.contactFormEditorResponseEmailDescription]: 'Email address that messages are sent to',
    [TrKey.contactFormEditorResponseEmailPlaceholder]: 'info@minforening.se',
    [TrKey.contactFormEditorMarginBottomLabel]: 'Margin bottom',
    [TrKey.contactFormEditorMarginBottomDescription]: 'How much space there is below the form',
    [TrKey.contactFormEditorMarginBottomPlaceholder]: 'Select value',

    [TrKey.sponsorEditorTopTextLabel]: 'Header',
    [TrKey.ytVideoEditorUrlLabel]: 'Youtube link',
    [TrKey.ytVideoEditorUrlDescription]: 'Paste the full Youtube link',
    [TrKey.ytVideoEditorMarginBottomLabel]: 'Margin bottom',
    [TrKey.ytVideoEditorMarginBottomDescription]: 'How much space there is below the video',
    [TrKey.ytVideoEditorMarginBottomPlaceholder]: 'Select value',

    [TrKey.foodMenuEditorItemsTitle]: 'Items',
    [TrKey.foodMenuEditorItemsTitleLabel]: 'Name',
    [TrKey.foodMenuEditorItemsTitleDescription]: 'The name of the item',
    [TrKey.foodMenuEditorItemsPriceLabel]: 'Price',
    [TrKey.foodMenuEditorItemsPriceDescription]: 'The price of the item',
    [TrKey.foodMenuEditorItemsDescriptionLabel]: 'Description',
    [TrKey.foodMenuEditorItemsDescriptionDescription]: 'The description of the item',
    [TrKey.foodMenuEditorItemsCategoryLabel]: 'Category',
    [TrKey.foodMenuEditorItemsCategoryDescription]: 'Categorized items will be grouped together',

    // Content types
    [TrKey.contentTypeAccordion]: 'Accordion',
    [TrKey.contentTypeBlog]: 'News feed',
    [TrKey.contentTypeBullets]: 'Bulletpoints',
    [TrKey.contentTypeGallery]: 'Gallery',
    [TrKey.contentTypeButton]: 'Button',
    [TrKey.contentTypeForm]: 'Form',
    [TrKey.contentTypeGrid]: 'Section',
    [TrKey.contentTypeHeader]: 'Header',
    [TrKey.contentTypeImage]: 'Image',
    [TrKey.contentTypeRichtext]: 'Textbox',
    [TrKey.contentTypeDocument]: 'Document',
    [TrKey.contentTypeSponsors]: 'Sponsors',
    [TrKey.contentTypeTipsbox]: 'Tipsbox',
    [TrKey.contentTypeCalendar]: 'Calendar',
    [TrKey.contentTypeContactform]: 'Contact form',
    [TrKey.contentTypeQuicklinks]: 'Quicklinks',
    [TrKey.contentTypeYtvideo]: 'Video',
    [TrKey.contentTypeTopsection]: 'Top section',
    [TrKey.contentTypeVideoHero]: 'Video Hero',
    [TrKey.contentTypeImageCards]: 'Image cards',
    [TrKey.contentTypeImageCollage]: 'Image collage',
    [TrKey.contentTypeLogoSection]: 'Logotypes',
    [TrKey.contentTypeServiceCard]: 'Offer',
    [TrKey.contentTypeDSolutionsBadge]: 'DSolution badge',
    [TrKey.contentTypeFoodMenu]: 'Food menu',
    [TrKey.contentTypeOpeningHours]: 'Opening hours',
    
    // Editor center
    [TrKey.editorCenterNoPageSelected]: 'No page selected',
    [TrKey.editorCenterSelectPage]: 'Select a page to start editing',
    [TrKey.editorCenterMoveSectionUp]: 'Move section up',
    [TrKey.editorCenterMoveSectionDown]: 'Move section down',
    [TrKey.editorCenterAddSectionAbove]: 'Add section above',
    [TrKey.editorCenterAddSectionBelow]: 'Add section below',
    [TrKey.editorCenterEditSection]: 'Edit section',
    [TrKey.editorCenterDroppableText]: 'Drag content here',
    [TrKey.editorCenterDroppableHoverText]: 'Drop content here',

    // CMS Editor
    [TrKey.cmsEditorLeftHeader]: 'Models',
    [TrKey.cmsEditorCenterHeader]: 'You are editing {entryName}',
    [TrKey.cmsEditorNoActiveEntry]: 'Select an entry in the left menu',

    // Ecommerce
    [TrKey.ecommerceRouteTitle]: 'E-commerce',
  }
